import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { academylist, listsetting, savecertificaterecord } from "../../../services/admin";
import { stuclasslist, studivisionlist, stuacademicyearlist, roleList } from "../../../services/master";
import { studentfilter } from "../../../services/student";
import { teacherlist, teacherview } from "../../../services/teacher";
import { workerlist, workerviewbasic } from "../../../services/admin";
import { toast } from "react-toastify";
import tcTemplate from "../../../assets/images/tc.jpeg";
import studyTemplate from "../../../assets/images/study.jpeg";


// ── certificate templates ──────────────────────────────────────────────────
const CERT_TYPES = {
  student: [
    { value: "BONAFIDE",   label: "Bonafide Certificate" },
    { value: "STUDY",      label: "Study Certificate" },
    { value: "TRANSFER",   label: "Transfer Certificate" },
    { value: "CONDUCT",    label: "Conduct Certificate" },
    { value: "ATTENDANCE", label: "Attendance Certificate" },
  ],
  teacher: [
    { value: "RELIEVING",   label: "Relieving Certificate" },
    { value: "EXPERIENCE",  label: "Experience Certificate" },
    { value: "OFFER",       label: "Offer Letter" },
  ],
  worker: [
    { value: "RELIEVING",   label: "Relieving Certificate" },
    { value: "EXPERIENCE",  label: "Experience Certificate" },
  ],
};

export function buildContent(certType, data, schoolName) {
  const name         = data.student_name || data.teacher_name || data.worker_name || data.name || "—";
  const father       = data.father_name || "—";
  const cls          = data.class_name   || "—";
  const sec          = data.section_name || "—";
  const dob          = data.date_of_birth ? moment(data.date_of_birth).format("DD-MM-YYYY") : "—";
  const admNo        = data.admission_number || "—";
  const admDate      = data.admission_date   ? moment(data.admission_date).format("DD-MM-YYYY") : "—";
  const year         = data.aca_year || data.year_name || "—";
  const desig        = data.designation || data.desi_name || "—";
  const joinDate     = data.join_date ? moment(data.join_date).format("DD-MM-YYYY") : "—";
  const purpose      = data.purpose || "—";
  const fromYear     = data.from_year  || (data.created_at ? moment(data.created_at).format("YYYY") : "—");
  const toYear       = data.to_year    || String(moment().year());
  const fromClass    = data.from_class || "—";
  const toClass      = data.to_class   || cls;
  const tcNo         = data.tc_no      || "—";
  const leavingDate  = data.leaving_date ? moment(data.leaving_date).format("DD-MM-YYYY") : "—";
  const reason       = data.reason     || "—";
  const conduct      = data.conduct    || "—";
  const workedDays   = data.working_days_attended || "—";
  const totalDays    = data.total_working_days    || "—";
  const attendancePct = data.attendance_percentage || "—";
  const employeeId     = data.employee_id || data.username || "—";
  const lastWorkingDay = data.last_working_day ? moment(data.last_working_day).format("DD-MM-YYYY") : "—";
  const relievingDate  = data.relieving_date   ? moment(data.relieving_date).format("DD-MM-YYYY")   : "—";

  switch (certType) {
    case "BONAFIDE":
      return `This is to certify that <strong>${name}</strong> (Admission No: <strong>${admNo}</strong>)
              is a bonafide student of our institution.
              <br/><br/>He/She is currently studying in <strong>Class ${cls} (Section ${sec})</strong>
              for the academic year <strong>${year}</strong>.
              <br/><br/>Date of Birth: <strong>${dob}</strong>
              <br/><br/>This certificate is issued upon the request of the student for <strong>${purpose}</strong>.`;

    case "STUDY":
      return `This is to certify that <strong>${name}</strong> (Admission No: <strong>${admNo}</strong>)
              has studied in our school from <strong>${fromYear}</strong> to <strong>${toYear}</strong>.
              <br/><br/>During this period, he/she studied from Class <strong>${fromClass}</strong> to Class <strong>${toClass}</strong>.
              <br/><br/>His/Her Date of Birth as per school records is <strong>${dob}</strong>.
              <br/><br/>This certificate is issued upon request for <strong>${purpose}</strong>.`;

    case "TRANSFER":
      return `Admission No: <strong>${admNo}</strong> &nbsp;&nbsp; TC No: <strong>${tcNo}</strong>
              <br/><br/>
              1. Name of the Student: <strong>${name}</strong><br/>
              2. Father's / Guardian's Name: <strong>${father}</strong><br/>
              3. Date of Birth: <strong>${dob}</strong><br/>
              4. Class Last Studied: <strong>${cls}</strong><br/>
              5. Academic Year: <strong>${year}</strong><br/>
              6. Date of Admission: <strong>${admDate}</strong><br/>
              7. Date of Leaving: <strong>${leavingDate}</strong><br/>
              8. Reason for Leaving: <strong>${reason}</strong><br/>
              9. Conduct: <strong>${conduct}</strong>
              <br/><br/>Certified that the above information is correct as per school records.`;

    case "CONDUCT":
      return `This is to certify that <strong>${name}</strong> (Admission No: <strong>${admNo}</strong>)
              was a student of our school from <strong>${fromYear}</strong> to <strong>${toYear}</strong>.
              <br/><br/>During this period, his/her conduct and behavior were found to be <strong>${conduct}</strong>.
              <br/><br/>We wish him/her success in future endeavors.`;

    case "ATTENDANCE":
      return `This is to certify that <strong>${name}</strong> (Admission No: <strong>${admNo}</strong>)
              studying in Class <strong>${cls}</strong>, Section <strong>${sec}</strong>, has attended school
              for <strong>${workedDays}</strong> days out of <strong>${totalDays}</strong> days
              during the academic year <strong>${year}</strong>.
              <br/><br/>Attendance Percentage: <strong>${attendancePct}%</strong>
              <br/><br/>This certificate is issued upon request.`;

    case "RELIEVING":
      return `This is to certify that <strong>${name}</strong> (Employee ID: <strong>${employeeId}</strong>)
              was working with our institution as <strong>${desig}</strong>
              from <strong>${joinDate}</strong> to <strong>${lastWorkingDay}</strong>.
              <br/><br/>He/She has been relieved from his/her duties with effect from
              <strong>${relievingDate}</strong> after completing all responsibilities and formalities.
              <br/><br/>We thank him/her for the services rendered and wish success in future endeavors.`;

    case "EXPERIENCE":
      return `This is to certify that <strong>${name}</strong> (Employee ID: <strong>${employeeId}</strong>)
              worked in our institution as <strong>${desig}</strong>
              from <strong>${joinDate}</strong> to <strong>${lastWorkingDay}</strong>.
              <br/><br/>During this period, he/she performed duties sincerely and diligently.
              His/Her conduct was found to be <strong>${conduct}</strong>.
              <br/><br/>We wish him/her all the best for future endeavors.`;

    case "OFFER":
      return `We are pleased to offer <strong>${name}</strong> the position of
              <strong>${desig}</strong> at <strong>${schoolName}</strong>,
              with effect from <strong>${moment().format("DD-MM-YYYY")}</strong>.
              <br/><br/>Kindly sign and return a copy of this letter as a token of your acceptance.`;

    default:
      return "";
  }
}

// ── Certificate print layout ──────────────────────────────────────────────
export function CertificateSheet({ cert, headerUrl, footerUrl, schoolName, schoolAddress, place, certLabel }) {
  const content = buildContent(cert.type, cert.data, schoolName);
  const isRelieving = cert.type === "RELIEVING";
  return (
    <div className="certificate-sheet" style={{
      width: "100%", border: "2px solid #ccc", borderRadius: "6px", marginBottom: "24px",
      background: "#fff", pageBreakAfter: "always", overflow: "hidden",
    }}>
      {/* Header image */}
      {headerUrl && (
        <div style={{ width: "100%", maxHeight: "140px", overflow: "hidden" }}>
          <img src={headerUrl} alt="Header" style={{ width: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}

      {/* Certificate body */}
      <div style={{ padding: "28px 40px" }}>
        <div className="text-center mb-3">
          <h4 style={{ fontWeight: "bold", letterSpacing: "2px", textTransform: "uppercase",
            borderBottom: "2px solid #333", display: "inline-block", paddingBottom: "4px" }}>
            {certLabel}
          </h4>
        </div>

        <p style={{ fontSize: "14px", textAlign: "justify", lineHeight: "2" }}
          dangerouslySetInnerHTML={{ __html: content }} />

        <div className="row mt-5">
          <div className="col-4 text-center">
            <div style={{ fontSize: "13px" }}>Date: {moment().format("DD-MM-YYYY")}</div>
            {place && <div style={{ fontSize: "13px", marginTop: "4px" }}>Place: {place}</div>}
          </div>
          <div className="col-4"></div>
          <div className="col-4 text-center">
            <div style={{ borderTop: "1px solid #333", paddingTop: "6px", fontSize: "13px" }}>
              {isRelieving ? "Authorized Signatory" : "Signature of Principal"}
            </div>
            <div style={{ fontSize: "13px" }}>{schoolName}</div>
            {isRelieving && schoolAddress && (
              <div style={{ fontSize: "12px", marginTop: "2px" }}>{schoolAddress}</div>
            )}
          </div>
        </div>
      </div>

      {/* Footer image */}
      {footerUrl && (
        <div style={{ width: "100%", maxHeight: "100px", overflow: "hidden" }}>
          <img src={footerUrl} alt="Footer" style={{ width: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}
    </div>
  );
}

// ── Kidspark Transfer Certificate — printed over the tc.jpeg template ────────
// Kids Park Play School TC (image 1024 x 1536): English section on the top half,
// Tamil section on the bottom half. Values are positioned as a percentage of the
// image. Pre-printed choice fields (Pre-KG/LKG/UKG, Good, Yes/No, Parent's
// Request, Valappady) are left untouched. Tweak top/left/w to nudge a field.
export function TcImageSheet({ cert }) {
  const d   = cert.data || {};
  const inWords = (v) => (v ? moment(v).format("Do MMMM YYYY") : "");
  const yr      = (v) => (v ? moment(v).format("YYYY") : "");
  // split a date into [DD, MM, YYYY] for the "__ / __ / ____" slots
  const parts   = (v) => (v ? [moment(v).format("DD"), moment(v).format("MM"), moment(v).format("YYYY")] : null);

  const name        = d.student_name || d.name || "";
  const father      = d.father_name  || d.guardian_name || "";
  const mother      = d.mother_name  || "";
  const fatherMother = [father, mother].filter(Boolean).join(" / ");
  const gender      = d.gender || "";
  const dobWords    = inWords(d.date_of_birth);
  const tcNo        = d.tc_number || d.tc_no || "";
  const admNo       = d.admission_number || "";
  const remarks     = d.remarks || "";
  const periodFrom  = yr(d.admission_date) || (d.aca_year || "");
  const periodTo    = yr(d.leaving_date) || moment().format("YYYY");

  const dob     = parts(d.date_of_birth);
  const leaving = parts(d.leaving_date);
  const issue   = parts(moment());

  // expand a date into 3 slot entries — left = [dayLeft%, monthLeft%, yearLeft%]
  const dateRow = (top, [dl, ml, yl], val, w = 9) =>
    val ? [
      { top, left: dl, w, val: val[0] },  // DD
      { top, left: ml, w, val: val[1] },  // MM
      { top, left: yl, w, val: val[2] },  // YYYY
    ] : [];

  // { top%, left%, w% (clip width), val }
  const fields = [
    // ── English section (top half) ──────────────────────────────
    { top: 19.1, left: 18,  w: 22, val: tcNo },          // T.C. No.
    { top: 19.1, left: 78,  w: 25, val: admNo },         // Admission No.
    { top: 21.8, left: 40,  w: 60, val: name },          // 1. Name of the Student
    { top: 23.8, left: 40,  w: 60, val: gender },        // 2. Gender
    { top: 25.7, left: 40,  w: 60, val: fatherMother },  // 3. Father's / Mother's Name
    { top: 27.7, left: 40,  w: 60, val: dobWords },      // 4. Date of Birth (in words)
    ...dateRow(30.2, [40, 47, 53], dob),                 // 5. Date of Birth (as per records)
    { top: 33.9, left: 45,  w: 14, val: periodFrom },    // 7. Period of Study — From
    { top: 33.9, left: 60,  w: 14, val: periodTo },      // 7. Period of Study — To
    ...dateRow(40.5, [40, 47, 53], leaving),             // 10. Date of Leaving School
    { top: 44.9, left: 40,  w: 60, val: remarks },       // 12. Remarks
    ...dateRow(52.4, [21, 26, 32], issue),               // Date (certify block)

    // ── Tamil section (bottom half) ─────────────────────────────
    { top: 67.1, left: 40,  w: 64, val: name },          // 1. மாணவர் பெயர்
    { top: 69.1, left: 40,  w: 64, val: fatherMother },  // 2. தந்தை / தாய் பெயர்
    ...dateRow(71.2, [40, 47, 53], dob),                 // 3. பிறந்த தேதி
    { top: 75.3, left: 47,  w: 14, val: periodFrom },    // 5. பயின்ற காலம் — From
    { top: 75.3, left: 60,  w: 14, val: periodTo },      // 5. பயின்ற காலம் — To
    ...dateRow(79.2, [40, 47, 53], leaving),             // 7. வெளியேறிய தேதி
    { top: 83.8, left: 40,  w: 64, val: remarks },       // 9. குறிப்புகள்
    ...dateRow(91.5, [15, 20, 28], issue),               // தேதி (certify block)
  ];

  return (
    <div className="certificate-sheet" style={{
      position: "relative", width: "600px", margin: "0 auto 24px",
      background: "#fff", pageBreakAfter: "always",
    }}>
      <img src={tcTemplate} alt="Transfer Certificate" crossOrigin="anonymous"
        style={{ width: "100%", display: "block" }} />
      {fields.filter((f) => f.val !== "" && f.val != null).map((f, i) => (
        <span key={i} style={{
          position: "absolute", top: `${f.top}%`, left: `${f.left}%`,
          width: f.w ? `${f.w}%` : "auto",
          fontSize: "11px", fontWeight: 600, color: "#15306b",
          fontFamily: "'Times New Roman', serif", lineHeight: 1,
          whiteSpace: "nowrap", overflow: "hidden",
        }}>{f.val}</span>
      ))}
    </div>
  );
}

// ── Kidspark Study Certificate — printed over the study.jpeg template ────────
// Kids Park Play School Study Certificate: English section (top half) + Tamil
// section (bottom half). Values are positioned as a percentage of the image.
// Pre-printed choice fields (Pre-KG/LKG/UKG, Valappady) are left untouched.
// Tweak top/left/w to nudge a field in the browser preview.
export function StudyImageSheet({ cert }) {
  const d = cert.data || {};
  // split a date into [DD, MM, YYYY] for the "__ / __ / ____" slots
  const parts = (v) => (v ? [moment(v).format("DD"), moment(v).format("MM"), moment(v).format("YYYY")] : null);

  const name         = d.student_name || d.name || "";
  const father       = d.father_name  || d.guardian_name || "";
  const mother       = d.mother_name  || "";
  const fatherMother = [father, mother].filter(Boolean).join(" / ");

  // academic year "2024-2025" → fromYY "24", toYY "25" (fills the "20__" slots)
  const acaParts = String(d.aca_year || d.year_name || "").split(/[^0-9]+/).filter(Boolean);
  const fromYY   = acaParts[0] ? acaParts[0].slice(-2) : "";
  const toYY     = acaParts[1] ? acaParts[1].slice(-2) : "";

  const issue = parts(moment());

  // expand a date into 3 slot entries — left = [dayLeft%, monthLeft%, yearLeft%]
  const dateRow = (top, [dl, ml, yl], val, w = 9) =>
    val ? [
      { top, left: dl, w, val: val[0] },  // DD
      { top, left: ml, w, val: val[1] },  // MM
      { top, left: yl, w, val: val[2] },  // YYYY
    ] : [];

  // { top%, left%, w% (clip width), val }
  const fields = [
    // ── English section (top half) ──────────────────────────────
    { top: 23.2, left: 31, w: 56, val: name },          // Master / Miss
    { top: 26.6, left: 49, w: 38, val: fatherMother },  // Son / Daughter of Mr. / Mrs.
    { top: 32.8, left: 56, w: 6,  val: fromYY },        // academic year 20__
    { top: 32.8, left: 67, w: 6,  val: toYY },          // - 20__
    ...dateRow(50.5, [24, 29, 34], issue),              // Date : __ / __ / ____

    // ── Tamil section (bottom half) ─────────────────────────────
    { top: 67, left: 53, w: 35, val: name },          // செல்வன் / செல்வி
    { top: 69.5, left: 31, w: 26, val: fatherMother },  // திரு / திருமதி
    { top: 74.5, left: 16, w: 6,  val: fromYY },        // 20__ கல்வியாண்டில்
    { top: 74.5, left: 28, w: 6,  val: toYY },          // - 20__
    ...dateRow(93.0, [21, 27, 32], issue),              // தேதி : __ / __ / ____
  ];

  return (
    <div className="certificate-sheet" style={{
      position: "relative", width: "600px", margin: "0 auto 24px",
      background: "#fff", pageBreakAfter: "always",
    }}>
      <img src={studyTemplate} alt="Study Certificate" crossOrigin="anonymous"
        style={{ width: "100%", display: "block" }} />
      {fields.filter((f) => f.val !== "" && f.val != null).map((f, i) => (
        <span key={i} style={{
          position: "absolute", top: `${f.top}%`, left: `${f.left}%`,
          width: f.w ? `${f.w}%` : "auto",
          fontSize: "11px", fontWeight: 600, color: "#15306b",
          fontFamily: "'Times New Roman', serif", lineHeight: 1,
          whiteSpace: "nowrap", overflow: "hidden",
        }}>{f.val}</span>
      ))}
    </div>
  );
}

function getCertTypes(roleId) {
  const id = Number(roleId);
  if (id === 4) return CERT_TYPES.student;
  if (id === 5) return CERT_TYPES.teacher;
  if (id > 5)   return CERT_TYPES.worker;
  return [];
}

// ── Main component ────────────────────────────────────────────────────────
export default function GenerateCertificate() {
  const baseUrl = (localStorage.getItem("activeBaseUrl") || "").replace("/api", "");
  const isKidspark = (localStorage.getItem("activeBaseUrl") || "").includes("kidspark");

  const [role, setRole]           = useState("");
  const [rlist, setRlist]         = useState([]);
  const [aclist, setAcList]       = useState([]);
  const [acaid, setAcaID]         = useState("");
  const [ayear, setAYear]         = useState("");
  const [alist, setAList]         = useState([]);
  const [classList, setClassList] = useState([]);
  const [selClass, setSelClass]   = useState("");
  const [secList, setSecList]     = useState([]);
  const [selSec, setSelSec]       = useState("");
  const [personList, setPersonList] = useState([]);
  const [selPerson, setSelPerson] = useState(null);
  const [certType, setCertType]   = useState("");
  const [certificates, setCertificates] = useState([]);
  const [schoolName, setSchoolName]         = useState("");
  const [schoolAddress, setSchoolAddress]   = useState("");
  const [place, setPlace]                   = useState("");
  const [purpose, setPurpose]           = useState("");
  const [certInputs, setCertInputs]     = useState({});
  const [headerUrl, setHeaderUrl]       = useState("");
  const [footerUrl, setFooterUrl]       = useState("");
  const [saving, setSaving]             = useState(false);
  const printRef = useRef(null);

  useEffect(() => {
    stuclasslist().then((res) => {
      if (res?.status) setClassList(res.data.map((d) => ({ value: d.id, label: d.class_name })));
    });
    studivisionlist().then((res) => {
      if (res?.status) setSecList(res.data.map((d) => ({ value: d.id, label: d.name })));
    });
    roleList().then((res) => {
      if (res.status === true) {
        setRlist(res.data);
        const first = res.data.find((r) => r.id > 3);
        if (first) setRole(String(first.id));
      }
    });
    academylist().then((res) => {
      if (res?.status) {
        const arr = res.data.details.map((d) => ({ value: d.id, label: d.name + " - " + d.code, name: d.name, address: d.address || "" }));
        setAcList(arr);
        const savedId = localStorage.getItem("AAcademy") || localStorage.getItem("academy");
        if (savedId) {
          const found = arr.find((a) => String(a.value) === String(savedId));
          if (found) setAcaID(found);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!acaid) return;
    const id = acaid.value;
    setSchoolName(acaid.name || "");
    setSchoolAddress(acaid.address || "");

    const temp = new FormData();
    temp.append("academy_id", id);
    stuacademicyearlist(temp).then((res) => {
      if (res?.status) setAList(res.data);
    });

    // Kidspark certificates use self-contained image templates — no header/footer
    // if (!isKidspark) {
      const settTemp = new FormData();
      settTemp.append("academy_id", id);
      listsetting(settTemp).then((resp) => {
        if (resp?.status && resp.data) {
          console.log("Certificate settings:", resp.data);
          if (resp.data.certificate_header) setHeaderUrl(baseUrl + "/" + resp.data.certificate_header);
          if (resp.data.certificate_footer) setFooterUrl(baseUrl + "/" + resp.data.certificate_footer);
        }
      });
    // }
  }, [acaid]);

  // load teacher / worker list when role changes
  useEffect(() => {
    setPersonList([]);
    setSelPerson(null);
    const aca = acaid?.value || localStorage.getItem("AAcademy") || "";
    if (!aca) return;

    if (Number(role) === 5) {
      teacherlist(aca).then((res) => {
        if (res.status === true) {
          setPersonList(res.data.details.map((d) => ({
            value: d.id, label: d.teacher_name + " (" + d.username + ")",
            data: { ...d, name: d.teacher_name, designation: d.desi_name },
          })));
        }
      });
    } else if (Number(role) > 5) {
      const temp = new FormData();
      temp.append("academy_id", aca);
      temp.append("status", 1);
      workerlist(temp).then((res) => {
        if (res.status === true) {
          setPersonList(res.data.details.map((d) => ({
            value: d.id, label: d.worker_name + " (" + d.username + ")",
            data: { ...d, name: d.worker_name, designation: d.type_name || d.designation || "" },
          })));
        }
      });
    }
  }, [role, acaid]);

  // auto-load students when class / section / year changes
  useEffect(() => {
    if (Number(role) !== 4 || !selClass) return;
    const aca = acaid?.value || localStorage.getItem("AAcademy") || "";
    if (!aca) return;
    setPersonList([]);
    setSelPerson(null);
    const temp = new FormData();
    temp.append("year", ayear);
    temp.append("class", selClass);
    if (selSec) temp.append("section", selSec);
    if (localStorage.getItem("Role") === "1") temp.append("academy", aca);
    studentfilter(temp).then((res) => {
      if (res.status === true) {
        const list = res.data.details || [];
        setPersonList(list.map((d) => ({ value: d.id, label: d.student_name + " (" + d.username + ")", data: d })));
      }
    });
  }, [selClass, selSec, ayear, acaid, role]);


  function handlePersonChange(selected) {
    if (!selected) { setSelPerson(null); return; }

    if (Number(role) === 5) {
      teacherview(selected.value).then((res) => {
        if (res?.status && res.data?.details) {
          const d = res.data.details;
          setSelPerson({
            ...selected,
            data: {
              ...selected.data,
              designation: d.desi_name || selected.data.designation || "",
              join_date:   d.adm_date  || selected.data.join_date   || "",
            },
          });
        } else {
          setSelPerson(selected);
        }
      });
    } else if (Number(role) > 5) {
      workerviewbasic(selected.value).then((res) => {
        if (res?.status && res.data?.details) {
          const d = res.data.details;
          setSelPerson({
            ...selected,
            data: {
              ...selected.data,
              designation: d.desi_name || d.type_name || selected.data.designation || "",
              join_date:   d.date_of_joining || d.adm_date || d.joining_date || d.created_at || selected.data.join_date || "",
            },
          });
        } else {
          setSelPerson(selected);
        }
      });
    } else {
      setSelPerson(selected);
    }
  }

  function buildSavePayload(userId) {
    const certLabel = getCertTypes(role).find((c) => c.value === certType)?.label || certType;
    const aca = (typeof acaid === "object" ? acaid?.value : acaid) || localStorage.getItem("AAcademy") || "";
    const temp = new FormData();
    temp.append("user_id", userId);
    temp.append("role_id", role);
    temp.append("cert_type", certType);
    temp.append("cert_label", certLabel);
    temp.append("academy_id", aca);
    temp.append("generated_date", moment().format("YYYY-MM-DD"));
    return temp;
  }

  function handlePreview() {
    if (!certType) { toast.error("Please select certificate type"); return; }
    const certLabel = getCertTypes(role).find((c) => c.value === certType)?.label || certType;

    if (selPerson) {
      setCertificates([{ type: certType, label: certLabel, data: { ...selPerson.data, purpose, ...certInputs } }]);
    } else if (Number(role) === 4 && personList.length > 0) {
      setCertificates(personList.map((p) => ({ type: certType, label: certLabel, data: { ...p.data, purpose, ...certInputs } })));
    } else {
      toast.error("Please select a class or person first");
    }
  }

  async function elementToPdf(element) {
    const imgs = Array.from(element.querySelectorAll("img"));
    await Promise.all(
      imgs.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => { img.onload = resolve; img.onerror = resolve; })
      )
    );
    const canvas    = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: "#ffffff", logging: false });
    const pdf       = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight= pdf.internal.pageSize.getHeight();
    const imgData   = canvas.toDataURL("image/jpeg", 0.85);
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
    let heightLeft  = imgHeight;
    let position    = 0;
    pdf.addImage(imgData, "JPEG", 0, position, pageWidth, imgHeight);
    heightLeft -= pageHeight;
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, pageWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    return pdf;
  }

  async function handleGenerate() {
    if (certificates.length === 0) return;
    setSaving(true);
    const certLabel = getCertTypes(role).find((c) => c.value === certType)?.label || certType;
    try {
      if (selPerson) {
        const pdf     = await elementToPdf(printRef.current);
        const payload = buildSavePayload(selPerson.data.user_id || selPerson.value);
        payload.append("pdf_file", pdf.output("blob"), "certificate.pdf");
        const res = await savecertificaterecord(payload);
        if (res?.status) toast.success("Certificate generated and saved successfully");
        else toast.error(res?.message || "Failed to save certificate");
      } else {
        const sheets = Array.from(printRef.current.querySelectorAll(".certificate-sheet"));
        let saved = 0, failed = 0;
        for (let i = 0; i < personList.length; i++) {
          try {
            const p   = personList[i];
            const pdf = sheets[i] ? await elementToPdf(sheets[i]) : null;
            const payload = buildSavePayload(p.data.user_id || p.value);
            if (pdf) payload.append("pdf_file", pdf.output("blob"), "certificate.pdf");
            const res = await savecertificaterecord(payload);
            res?.status ? saved++ : failed++;
          } catch {
            failed++;
          }
        }
        if (saved > 0) toast.success(`${saved} certificate${saved !== 1 ? "s" : ""} saved successfully${failed > 0 ? `, ${failed} failed` : ""}`);
        else toast.error("Failed to save certificates");
      }
    } catch (err) {
      toast.error("Failed to generate certificate: " + (err?.message || "Unknown error"));
    } finally {
      setSaving(false);
    }
  }

  function handlePrint() {
    if (!printRef.current) return;
    const content = printRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html><head><title>Certificate</title>
      <base href="${window.location.origin}/"/>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
      <style>
        body { font-family: 'Times New Roman', serif; margin: 20px; }
        .certificate-sheet { border: 2px solid #ccc; border-radius: 6px; margin-bottom: 24px; page-break-after: always; }
        @media print { body { margin: 0; } .certificate-sheet { border: none; margin: 0; } }
      </style>
      </head><body>${content}</body></html>`);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 500);
  }

  const certOptions = getCertTypes(role);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Certificate Generator</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Certificates</a></li>
          <li className="breadcrumb-item active">Generate Certificate</li>
        </ol>
      </div>

      <div className="row">
        {/* ── Left panel: controls ── */}
        <div className="col-xl-4 col-lg-5">
          <div className="card custom-card">
            <div className="card-body">
              <div style={{ borderLeft: "4px solid #6259ca", paddingLeft: "10px", marginBottom: "16px" }}>
                <h6 className="mb-0 fw-bold" style={{ color: "#6259ca" }}>
                  Selection
                </h6>
              </div>

              {localStorage.getItem("Role") === "1" && (
                <div className="mb-3">
                  <label className="form-label">Academy</label>
                  <Select options={aclist} value={acaid} onChange={(e) => { setAcaID(e); }} placeholder="Select Academy" isClearable isSearchable />
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">Role <span className="text-danger">*</span></label>
                <select className="form-control" value={role} onChange={(e) => { setRole(e.target.value); setCertType(""); setCertificates([]); setSelPerson(null); }}>
                  <option value="" disabled>Select Role</option>
                  {rlist.filter((item) => item.id > 3).map((item) => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>

              {Number(role) === 4 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <select className="form-control" value={ayear} onChange={(e) => setAYear(e.target.value)}>
                      <option value="">Select Year</option>
                      {alist.map((y) => <option key={y.id} value={y.id}>{y.aca_year}</option>)}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Class <span className="text-danger">*</span></label>
                    <select className="form-control" value={selClass} onChange={(e) => { setSelClass(e.target.value); setSelPerson(null); }}>
                      <option value="">Select Class</option>
                      {classList.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Section <span className="text-muted tx-12">(optional)</span></label>
                    <select className="form-control" value={selSec} onChange={(e) => { setSelSec(e.target.value); setSelPerson(null); }}>
                      <option value="">All Sections</option>
                      {secList.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </div>
                  {selClass && (
                    <div className="mb-3">
                      <label className="form-label">Student <span className="text-muted tx-12">(optional — leave blank for all)</span></label>
                      <Select options={personList} value={selPerson} onChange={setSelPerson} placeholder="All students" isClearable isSearchable />
                      {/* {personList.length > 0 && <small className="text-muted">{personList.length} student{personList.length !== 1 ? "s" : ""} loaded</small>} */}
                    </div>
                  )}
                </>
              )}

              {Number(role) >= 5 && (
                <div className="mb-3">
                  <label className="form-label">
                    {rlist.find((r) => String(r.id) === String(role))?.name || "Person"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Select options={personList} value={selPerson} onChange={handlePersonChange}
                    placeholder={`Select ${rlist.find((r) => String(r.id) === String(role))?.name || "Person"}`}
                    isClearable isSearchable />
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">Certificate Type <span className="text-danger">*</span></label>
                <select className="form-control" value={certType} onChange={(e) => { setCertType(e.target.value); setPurpose(""); setCertInputs({}); setCertificates([]); }}>
                  <option value="">-- Select Certificate --</option>
                  {certOptions.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
              </div>

              {/* BONAFIDE / STUDY – purpose */}
              {Number(role) === 4 && (certType === "BONAFIDE" || certType === "STUDY") && (
                <div className="mb-3">
                  <label className="form-label">Purpose </label>
                  <input type="text" className="form-control" placeholder="e.g. school admission, bank purpose"
                    value={purpose} onChange={(e) => setPurpose(e.target.value)} />
                </div>
              )}

              {/* STUDY – from class */}
              {Number(role) === 4 && certType === "STUDY" && (
                <div className="mb-3">
                  <label className="form-label">From Class</label>
                  <input type="text" className="form-control" placeholder="e.g. 1"
                    value={certInputs.from_class || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, from_class: e.target.value }))} />
                </div>
              )}

              {/* TRANSFER – extra fields */}
              {Number(role) === 4 && certType === "TRANSFER" && (<>
                <div className="mb-3">
                  <label className="form-label">TC No</label>
                  <input type="text" className="form-control" placeholder="TC Number"
                    value={certInputs.tc_no || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, tc_no: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Date of Leaving</label>
                  <input type="date" className="form-control"
                    value={certInputs.leaving_date || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, leaving_date: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Reason for Leaving</label>
                  <input type="text" className="form-control" placeholder="e.g. Migration"
                    value={certInputs.reason || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, reason: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Conduct</label>
                  <input type="text" className="form-control" placeholder="e.g. Good"
                    value={certInputs.conduct || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, conduct: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Remarks</label>
                  <input type="text" className="form-control" placeholder="e.g. Nil"
                    value={certInputs.remarks || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, remarks: e.target.value }))} />
                </div>
              </>)}

              {/* CONDUCT – conduct */}
              {Number(role) === 4 && certType === "CONDUCT" && (
                <div className="mb-3">
                  <label className="form-label">Conduct</label>
                  <input type="text" className="form-control" placeholder="e.g. Good"
                    value={certInputs.conduct || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, conduct: e.target.value }))} />
                </div>
              )}

              {/* ATTENDANCE – attendance fields */}
              {Number(role) === 4 && certType === "ATTENDANCE" && (<>
                <div className="mb-3">
                  <label className="form-label">Working Days Attended</label>
                  <input type="number" className="form-control" placeholder="e.g. 210"
                    value={certInputs.working_days_attended || ""}
                    onChange={(e) => {
                      const attended = e.target.value;
                      const total = certInputs.total_working_days;
                      const pct = attended && total ? ((Number(attended) / Number(total)) * 100).toFixed(2) : "";
                      setCertInputs((p) => ({ ...p, working_days_attended: attended, attendance_percentage: pct }));
                    }} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Total Working Days</label>
                  <input type="number" className="form-control" placeholder="e.g. 220"
                    value={certInputs.total_working_days || ""}
                    onChange={(e) => {
                      const total = e.target.value;
                      const attended = certInputs.working_days_attended;
                      const pct = attended && total ? ((Number(attended) / Number(total)) * 100).toFixed(2) : "";
                      setCertInputs((p) => ({ ...p, total_working_days: total, attendance_percentage: pct }));
                    }} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Attendance Percentage</label>
                  <input type="text" className="form-control" readOnly
                    value={certInputs.attendance_percentage || ""} />
                </div>
              </>)}

              {/* RELIEVING – teacher/worker extra fields */}
              {Number(role) >= 5 && certType === "RELIEVING" && (<>
                <div className="mb-3">
                  <label className="form-label">Last Working Day</label>
                  <input type="date" className="form-control"
                    value={certInputs.last_working_day || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, last_working_day: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Relieving Date</label>
                  <input type="date" className="form-control"
                    value={certInputs.relieving_date || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, relieving_date: e.target.value }))} />
                </div>
              </>)}

              {/* EXPERIENCE – teacher/worker extra fields */}
              {Number(role) >= 5 && certType === "EXPERIENCE" && (<>
                <div className="mb-3">
                  <label className="form-label">Last Working Day</label>
                  <input type="date" className="form-control"
                    value={certInputs.last_working_day || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, last_working_day: e.target.value }))} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Conduct</label>
                  <input type="text" className="form-control" placeholder="e.g. Good"
                    value={certInputs.conduct || ""}
                    onChange={(e) => setCertInputs((p) => ({ ...p, conduct: e.target.value }))} />
                </div>
              </>)}

              <div className="mb-3">
                <label className="form-label">Place</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Chennai"
                  value={place}
                  onChange={(e) => setPlace(e.target.value)}
                />
              </div>

              <button type="button" className="btn btn-success w-100" onClick={handlePreview}>
                Preview Certificate
              </button>
            </div>
          </div>

        </div>

        {/* ── Right panel: preview ── */}
        <div className="col-xl-8 col-lg-7">
          <div className="card custom-card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <div style={{ borderLeft: "4px solid #19b159", paddingLeft: "10px" }}>
                <h6 className="mb-0 fw-bold" style={{ color: "#19b159" }}>
                  Preview
                  {certificates.length > 0 && <span className="badge bg-success ms-2">{certificates.length}</span>}
                </h6>
              </div>
              {certificates.length > 0 && (
                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-success btn-sm me-2" onClick={handleGenerate} disabled={saving}>
                    {saving
                      ? <><span className="spinner-border spinner-border-sm me-1" role="status"></span>Saving...</>
                      : <> Generate &amp; Save</>
                    }
                  </button>
                  <button type="button" className="btn btn-info btn-sm" onClick={handlePrint}>
                    Print All
                  </button>
                </div>
              )}
            </div>
            <div className="card-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
              {certificates.length === 0 ? (
                <div className="text-center text-muted py-5">
                  <p className="mt-2">Select options and click <strong>Preview Certificate</strong> to preview, then <strong>Generate &amp; Save</strong> to save to the profile</p>
                </div>
              ) : (
                <div ref={printRef}>
                  {certificates.map((cert, idx) => (
                    (isKidspark && cert.type === "TRANSFER") ? (
                      <TcImageSheet key={idx} cert={cert} />
                    ) : (isKidspark && cert.type === "STUDY") ? (
                      <StudyImageSheet key={idx} cert={cert} />
                    ) : (
                      <CertificateSheet
                        key={idx}
                        cert={cert}
                        headerUrl={headerUrl}
                        footerUrl={footerUrl}
                        schoolName={schoolName}
                        schoolAddress={schoolAddress}
                        place={place}
                        certLabel={cert.label}
                      />
                    )
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
